import { EventScheduledReminders_eventScheduledReminders } from 'generated/EventScheduledReminders';
import { OutgoingMessages_scheduledMessages } from 'generated/OutgoingMessages';

export type Message = OutgoingMessages_scheduledMessages;
export type Reminder = EventScheduledReminders_eventScheduledReminders;

export function isReminder(reminder: Message | Reminder): reminder is Reminder {
  return reminder.__typename === 'EventScheduledReminder';
}
